import { useState } from 'react';
import NachWrapper from '../components/NachWrapper';
import BankMasterForm from './BankMasterForm';
import BankMasterTables from './BankMasterTables';
import { dummyData } from './data/dummyData';

function BankMaster() {
  const [bankDetailsData, setBankDetailsData] = useState(dummyData);
  const [filter, setFilter] = useState({});
  return (
    <NachWrapper title="Bank Master">
      <BankMasterForm
        bankData={bankDetailsData}
        setFilter={setFilter}
        setBankData={setBankDetailsData}
      />
      <BankMasterTables filter={filter} data={bankDetailsData} onSubmit={() => Promise.resolve()} />
    </NachWrapper>
  );
}

export default BankMaster;
